import { axios, toCamelCase, toSnakeCase } from '@utils';

async function fetchActivity(params) {
  const { data } = await axios.get('/api/v1/providers/profile_activity', {
    params: toSnakeCase(params),
  });
  return toCamelCase(data);
}

export {
  // eslint-disable-next-line import/prefer-default-export
  fetchActivity,
};
